import { isString } from 'lodash';

const PRODUCTION_URL_EXP = /(^https?:\/\/app.networkapp.com)/;

export function isLocalLink(url) {
    return isString(url) && (url.startsWith(location.origin) || PRODUCTION_URL_EXP.test(url) || !url.match(/^(https?:|\/\/)/));
}
